var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchCandidates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "human-resources",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.684,
    height: 40.684,
    viewBox: "0 0 40.684 40.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M25.826,0A14.854,14.854,0,0,0,14.511,24.482l-1.536,1.536-2.809-2.81L8.48,24.894,9.6,26.018l-8.558,8.56A3.576,3.576,0,1,0,6.1,39.636l8.558-8.56L15.784,32.2l1.686-1.685-2.81-2.81L16.2,26.169A14.857,14.857,0,1,0,25.826,0ZM4.417,37.951a1.192,1.192,0,0,1-1.685-1.687l5.451-5.452L9.868,32.5Zm7.136-7.138L9.867,29.126,11.289,27.7l1.686,1.686Zm14.272-3.474A12.477,12.477,0,1,1,38.3,14.861,12.49,12.49,0,0,1,25.826,27.338Z",
    fill: "#1a8fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M256.366,82.19a4.538,4.538,0,1,0-6.608,0,6.212,6.212,0,0,0-2.907,5.257v3.2h12.422v-3.2A6.212,6.212,0,0,0,256.366,82.19Zm-3.3-5.263a2.155,2.155,0,1,1-2.154,2.155A2.157,2.157,0,0,1,253.062,76.927Zm3.827,11.338h-7.654v-.818a3.827,3.827,0,0,1,7.654,0Z",
    transform: "translate(-227.236 -68.62)",
    fill: "#1a8fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCandidates);
export default __webpack_public_path__ + "static/media/search_candidates.65064335357709ba4228ce0216fdd49e.svg";
export { ForwardRef as ReactComponent };